import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchMediaMeta } from "../services/thunks/cloudFlareThunks";
import defaultImage from "../assets/defaultImage.jpg";

const imageCache = new Map(); 

const CloudflareImage = ({
  imageUrl,
  alt = "Image",
  className = "w-10 h-10 object-cover",
}) => {
  const dispatch = useDispatch();
  const [imageSrc, setImageSrc] = useState(() => {
    if (imageUrl instanceof File) return URL.createObjectURL(imageUrl);
    if (imageCache.has(imageUrl)) return imageCache.get(imageUrl);
    return defaultImage;
  });

  const hasLoaded = useRef(false);

  useEffect(() => {
    let isMounted = true;

    const loadImage = async () => {
      if (!imageUrl) return;

      if (imageUrl instanceof File) {
        const objectUrl = URL.createObjectURL(imageUrl);
        setImageSrc(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
      }

      if (imageCache.has(imageUrl)) {
        if (!hasLoaded.current) {
          setImageSrc(imageCache.get(imageUrl));
          hasLoaded.current = true;
        }
        return;
      }

      try {
        const key = imageUrl.split("/").pop();
        const { res } = await dispatch(fetchMediaMeta({ key })).unwrap();
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);

        if (isMounted) {
          imageCache.set(imageUrl, blobUrl);
          setImageSrc(blobUrl);
          hasLoaded.current = true;
        }
      } catch (err) {
        console.error("CloudflareImage fetch error:", err);
        if (isMounted) setImageSrc(defaultImage);
      }
    };

    loadImage();

    return () => {
      isMounted = false;
    };
  }, [imageUrl, dispatch]);

  return <img src={imageSrc} alt={alt} className={className} />;
};

export default CloudflareImage;
